import { render, staticRenderFns } from "./RevisoesListagemBotoesAcoes.vue?vue&type=template&id=191a2da6"
import script from "./RevisoesListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./RevisoesListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports